import { InteractionCapabilities as component, Props } from './component'
import { connect } from 'react-redux'
import { Dispatch } from 'redux'
import { setHovercapability, setTouchCapability } from './actions'

function mapDispatchToProps(
  dispatch: Dispatch
): Pick<Props, 'capabilitiesToTestFor'> {
  return {
    capabilitiesToTestFor: [
      [
        'touchstart',
        (isAble: boolean) => {
          dispatch(setTouchCapability(isAble))
        }
      ],
      [
        'mouseover',
        (isAble: boolean) => {
          dispatch(setHovercapability(isAble))
        }
      ]
    ]
  }
}

export default connect(
  undefined,
  mapDispatchToProps
)(component)
